import "../../stylesheets/PopupRegister.css";
import { useNavigate } from "react-router-dom";

function PopupValidateEmail({ user }) {
  const navigate = useNavigate();

  const handleEnter = () => {
    if (user) {
      localStorage.setItem("user-info", JSON.stringify(user));
    }

    // decidimos la ruta sin parsear localStorage otra vez
    if (user?.is_admin) {
      navigate("/admin");
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <div className="popup-register-container">
        <div className="popup">
          <div className="red">
            <img
              src={process.env.PUBLIC_URL + "/images/stage_characters/Popup_Imagen.png"}
              alt=""
            />
          </div>
          <h1>Código validado con éxito</h1>
          <h2>¡Ya puedes comenzar a jugar!</h2>
          <button className="btn red-btn" onClick={handleEnter}>
            Entrar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupValidateEmail;
